export default __webpack_public_path__ + "static/media/serie-lunga-icon.a4a82fc1.svg";